<template>
  <div>
    <h1>Image collections</h1>
    <v-btn :to="{name:'imageCollectionAdd'}">
      <v-icon>add</v-icon>Image collection
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="imageCollections"
      class="elevation-1"
      v-if="imageCollections"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'images', params:{id:props.item.id}}" small>{{ props.item.id }}</v-btn>
          </td>
          <td>{{ props.item.name }}</td>
          <td>
            <v-btn :to="{name:'imageCollection', params:{id:props.item.id}}" small>Edit</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ImageCollections",
  metaInfo() {
    return {
      title: "Image collections",
      titleTemplate: "%s - Image - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  data() {
    return {
      imageCollections: null,
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "",
          value: "id",
        },
      ],
      pagination: {
        rowsPerPage: -1,
      },
    };
  },
  methods: {
    async fetchImageCollections() {
      const response = await nbmlaw.get(`/cors/admin/image/imageCollections`);
      // console.log(response.data);
      this.imageCollections = response.data;
    },
  },
  created() {
    this.fetchImageCollections();
  },
};
</script>
